import script from "./pcenhome.vue?vue&type=script&setup=true&lang=js"
export * from "./pcenhome.vue?vue&type=script&setup=true&lang=js"

import "./pcenhome.vue?vue&type=style&index=0&id=42f5d008&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f5d008"]])

export default __exports__